/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Positions_TitleInputs */

const fr_help_positions_title = /** @type {(inputs: Help_Positions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Comment interpréter les positions ?`)
};

const en_help_positions_title = /** @type {(inputs: Help_Positions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. How should positions be interpreted?`)
};

/**
* | output |
* | --- |
* | "2. How should positions be interpreted?" |
*
* @param {Help_Positions_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_positions_title = /** @type {((inputs?: Help_Positions_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Positions_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_positions_title(inputs)
	return en_help_positions_title(inputs)
});